import { KeyCode } from '../../../../core/utils/src/dom';
var lastGeneratedId = 0;
var InputController = /** @class */ (function () {
    function InputController(component, node) {
        var _this = this;
        this.component = component;
        this.node = node;
        this.hasFocus = false;
        this.confirmedValue = '';
        this.lastEnteredValue = '';
        this.clickWasOutsideInput = false;
        this._inputListener = function (e) { return _this.inputListener(e); };
        this._changeListener = function () { return _this.changeListener(); };
        this._focusListener = function (e) { return _this.focusListener(e); };
        this._blurListener = function (e) { return _this.blurListener(e); };
        this.sendKeyEvent = function (nativeEvent) {
            var keyCode = nativeEvent.keyCode, key = nativeEvent.key, ctrlKey = nativeEvent.ctrlKey, shiftKey = nativeEvent.shiftKey, altKey = nativeEvent.altKey, metaKey = nativeEvent.metaKey;
            _this.component.notifyKeyEvent(nativeEvent.type, { keyCode: keyCode, key: key, ctrlKey: ctrlKey, shiftKey: shiftKey, altKey: altKey, metaKey: metaKey }, { nativeEvent: nativeEvent });
        };
        this.eventTargetIsInput = function (e) {
            return e.target instanceof Element && e.target.tagName === 'INPUT';
        };
        this._mousedownListener = function (e) { return _this.mousedownListener(e); };
        this._keydownListener = function (e) { return _this.keydownListener(e); };
        this._keyupListener = function (e) { return _this.keyupListener(e); };
        this._keypressListener = function (e) { return _this.keypressListener(e); };
        this.generatedId = node.tagName.toLowerCase() + "-" + lastGeneratedId++;
    }
    InputController.prototype.addListeners = function () {
        this.node.addEventListener('focusin', this._focusListener);
        this.node.addEventListener('focusout', this._blurListener);
        this.node.addEventListener('input', this._inputListener);
        this.node.addEventListener('change', this._changeListener);
        this.node.addEventListener('keydown', this._keydownListener);
        this.node.addEventListener('keyup', this._keyupListener);
        this.node.addEventListener('keypress', this._keypressListener);
        this.node.addEventListener('mousedown', this._mousedownListener);
    };
    InputController.prototype.removeListeners = function () {
        this.node.removeEventListener('focusin', this._focusListener);
        this.node.removeEventListener('focusout', this._blurListener);
        this.node.removeEventListener('input', this._inputListener);
        this.node.removeEventListener('change', this._changeListener);
        this.node.removeEventListener('keydown', this._keydownListener);
        this.node.removeEventListener('keyup', this._keyupListener);
        this.node.removeEventListener('keypress', this._keypressListener);
        this.node.removeEventListener('mousedown', this._mousedownListener);
    };
    // handles changes to the displayed value, coming from the UI
    InputController.prototype.valueUpdateHandler = function (newValue) {
        if (newValue !== this.component.getValue()) {
            this.lastEnteredValue = newValue;
            this.component.notifyInput(newValue);
        }
    };
    // handles changes coming from directly from API, not UI
    InputController.prototype.valueAttributeChangeHandler = function (value) {
        if (this.lastEnteredValue !== value) {
            this.confirmedValue = value;
        }
    };
    InputController.prototype.getSearchAttributesForBaseInput = function (hasValue) {
        var _this = this;
        var attributes = {
            type: 'search',
            leftIcon: 'search'
        };
        if (hasValue) {
            attributes.rightIcon = 'close';
            attributes.onRightIconClick = function () {
                _this.component.focus();
                _this.valueUpdateHandler('');
            };
        }
        return attributes;
    };
    InputController.prototype.inputListener = function (event) {
        this.valueUpdateHandler(event.target.value);
    };
    InputController.prototype.changeListener = function () {
        if (this.clickWasOutsideInput) {
            return;
        }
        var value = this.component.getValue();
        if (value !== this.confirmedValue) {
            this.confirmedValue = value;
            this.component.notifyChange(value);
        }
    };
    InputController.prototype.focusListener = function (e) {
        this.clickWasOutsideInput = false;
        if (!this.hasFocus) {
            this.component.notifyFocus();
        }
        this.hasFocus = true;
    };
    InputController.prototype.blurListener = function (e) {
        if (!this.clickWasOutsideInput) {
            this.hasFocus = false;
            this.changeListener();
            this.component.notifyBlur();
        }
    };
    InputController.prototype.mousedownListener = function (e) {
        if (!this.eventTargetIsInput(e)) {
            this.clickWasOutsideInput = true;
        }
    };
    InputController.prototype.keydownListener = function (e) {
        if (e.keyCode === KeyCode.enter) {
            this.changeListener();
        }
        this.sendKeyEvent(e);
    };
    InputController.prototype.keyupListener = function (e) {
        this.sendKeyEvent(e);
    };
    InputController.prototype.keypressListener = function (e) {
        this.sendKeyEvent(e);
    };
    return InputController;
}());
export default InputController;
//# sourceMappingURL=input-controller.js.map